import { CollectionData } from "./collections";
import { getCollectionImageUrl } from "@/lib/cloudinary";

export const lightGreyDescriptionParagraphs = [
  "Light Grey incarne la douceur et la lumière, à travers des teintes pastel et des textures aériennes. Chaque création évoque une élégance bohème, ancrée dans la simplicité et la poésie de la nature.",
  "Les motifs floraux et les matières légères s'unissent pour offrir une esthétique délicate et intemporelle. Cette collection invite à une promenade dans un univers de sérénité, où chaque détail raconte une histoire.",
  "Light Grey célèbre une beauté pure et naturelle, mêlant subtilité et raffinement pour des looks qui respirent la fraîcheur et l'harmonie. Une ode à la lumière et à la douceur des beaux jours.",
];

export const lightGreyCollection: CollectionData = {
  id: "2021-light-grey",
  title: "Collection Light Grey",
  descriptionParagraphs: lightGreyDescriptionParagraphs,
  images: [
    getCollectionImageUrl("2021-light-grey", "ALEXANDRA-GREY-LIGHT-GREY-01"),
    getCollectionImageUrl("2021-light-grey", "ALEXANDRA-GREY-LIGHT-GREY-02"),
    getCollectionImageUrl("2021-light-grey", "ALEXANDRA-GREY-LIGHT-GREY-03"),
    getCollectionImageUrl("2021-light-grey", "ALEXANDRA-GREY-LIGHT-GREY-04"),
    getCollectionImageUrl("2021-light-grey", "ALEXANDRA-GREY-LIGHT-GREY-05"),
    getCollectionImageUrl("2021-light-grey", "ALEXANDRA-GREY-LIGHT-GREY-06"),
    getCollectionImageUrl("2021-light-grey", "ALEXANDRA-GREY-LIGHT-GREY-07"),
    getCollectionImageUrl("2021-light-grey", "ALEXANDRA-GREY-LIGHT-GREY-08"),
    getCollectionImageUrl("2021-light-grey", "ALEXANDRA-GREY-LIGHT-GREY-09"),
    getCollectionImageUrl("2021-light-grey", "ALEXANDRA-GREY-LIGHT-GREY-10"),
    getCollectionImageUrl("2021-light-grey", "ALEXANDRA-GREY-LIGHT-GREY-11"),
    getCollectionImageUrl("2021-light-grey", "ALEXANDRA-GREY-LIGHT-GREY-12"),
    getCollectionImageUrl("2021-light-grey", "ALEXANDRA-GREY-LIGHT-GREY-13"),
  ],
  date: "04/21",
  bannerImage: getCollectionImageUrl("2021-light-grey", "ALEXANDRA-GREY-LIGHT-GREY-01"),
};
